<div class="avatar-container relative inline-block">
  <!-- Avatar -->
  <img
    src="/img/user.png"
    alt="Avatar"
    class="w-12 h-12 p-2 rounded-full border border-primary shadow cursor-pointer select-none"
    (click)="toggleMenu($event)"
  />

  <!-- Context Menu -->
  @if (isMenuOpen) {
  <div
    class="fixed bg-white border border-gray-200 shadow-lg rounded-md z-50 min-w-[150px] right-0"
  >
    <ul class="py-1 text-sm text-gray-700">
      <li>
        <p class="flex justify-center p-1 mb-1 border-b border-cinza font-semibold">
          {{ userName }}
        </p>
      </li>
      <!-- <li>
        <button (click)="closeMenu()" class="w-full text-left px-4 py-2 hover:bg-gray-100">
          Perfil
        </button>
      </li>
      <li>
        <button (click)="closeMenu()" class="w-full text-left px-4 py-2 hover:bg-gray-100">
          Configurações
        </button>
      </li> -->
      <li>
        <button
          (click)="logout()"
          class="w-full text-left px-4 py-2 hover:bg-gray-100 text-red-500"
        >
          Sair
        </button>
      </li>
    </ul>
  </div>
  }
</div>
